class MainATC extends HTMLElement{
  constructor(){
    super()
    this.handleVariantChange = this.handleVariantChange.bind(this)
  }

  connectedCallback(){
    this.submitForm = this.querySelector('form[action="/cart/add"]')
    this.variantInput = this.querySelector('input[name="id"]')
    this.quantityInput = this.querySelector('input[type="number"]')
    this.submitButton = this.querySelector('.main-atc__button')
    this.incrementBtn = this.querySelector('button[data-action="increment"]')
    this.decrementBtn = this.querySelector('button[data-action="decrement"]')
    this.quantitySelectors = this.querySelectorAll('.quantity-selector')

    // Listen for variant changes from variant selector or variant-selection-2
    const productContainer = this.closest('.product-container') || document
    const variantSelector = document.querySelector('variant-selector')
    const variantSelection2 = document.querySelector('[data-variant-selection-2]')
    if (variantSelector) {
      variantSelector.addEventListener('variant-changed', this.handleVariantChange)
    } else if (variantSelection2) {
      productContainer.addEventListener('variant-changed', this.handleVariantChange)
    } else {
      this.initializeNoVariants()
    }

    this.submitForm.addEventListener('submit', this.submitProduct.bind(this))
    this.incrementBtn.addEventListener('click', this.incrementQuantity.bind(this))
    this.decrementBtn.addEventListener('click', this.decrementQuantity.bind(this))

    // Sync quantity selector size with button height
    this.syncQuantitySelectorSize()
    this.resizeHandler = this.syncQuantitySelectorSize.bind(this)
    window.addEventListener('resize', this.resizeHandler)
  }

  syncQuantitySelectorSize(){
    if (!this.submitButton || !this.quantitySelectors.length) return
    
    const buttonHeight = this.submitButton.offsetHeight
    this.quantitySelectors.forEach(selector => {
      selector.style.width = `${buttonHeight}px`
      selector.style.height = `${buttonHeight}px`
    })
  }

  initializeNoVariants(){
    // For products without variants, use initial state from Liquid
    const isAvailable = this.submitButton.dataset.initialAvailable === 'true'
    this.updateButtonState(isAvailable, parseInt(this.quantityInput.max) || 0)
  }

  handleVariantChange(e){
    const { variantId, available, inventoryQuantity } = e.detail
    
    // Update variant ID in form
    if (this.variantInput && variantId) {
      this.variantInput.value = variantId
    }

    // Update quantity max
    if (this.quantityInput) {
      this.quantityInput.max = inventoryQuantity || 0
      // Ensure current value doesn't exceed max
      const currentValue = parseInt(this.quantityInput.value)
      if (currentValue > inventoryQuantity) {
        this.quantityInput.value = Math.max(1, inventoryQuantity)
      }
    }

    // Update button state
    this.updateButtonState(available, inventoryQuantity)
  }

  updateButtonState(isAvailable, inventoryQuantity){
    if (!this.submitButton) return

    // Remove existing stock attributes
    this.submitButton.removeAttribute('with-stock')
    this.submitButton.removeAttribute('without-stock')
    this.submitButton.disabled = false

    if (isAvailable && inventoryQuantity > 0) {
      this.submitButton.setAttribute('with-stock', '')
      this.submitButton.textContent = this.submitButton.dataset.available || 'In den Warenkorb'
    } else {
      this.submitButton.setAttribute('without-stock', '')
      this.submitButton.disabled = true
      this.submitButton.textContent = this.submitButton.dataset.notAvailable || 'Ausverkauft'
    }
  }

  submitProduct(e){
    e.preventDefault()
  }

  incrementQuantity(){
    const currentValue = parseInt(this.quantityInput.value)
    const maxValue = parseInt(this.quantityInput.max) || 999
    const newValue = Math.min(currentValue + 1, maxValue)
    this.quantityInput.value = newValue
    this.dispatchQuantityChanged(newValue)
  }

  decrementQuantity(){
    const currentValue = parseInt(this.quantityInput.value)
    const minValue = parseInt(this.quantityInput.min) || 1
    const newValue = Math.max(currentValue - 1, minValue)
    this.quantityInput.value = newValue
    this.dispatchQuantityChanged(newValue)
  }

  dispatchQuantityChanged(value){
    this.dispatchEvent(new CustomEvent('quantity-changed', { bubbles: true, detail: { quantity: parseInt(value, 10) || 1 } }))
  }

  disconnectedCallback(){
    const variantSelector = document.querySelector('variant-selector')
    const productContainer = this.closest('.product-container') || document
    if (variantSelector) {
      variantSelector.removeEventListener('variant-changed', this.handleVariantChange)
    }
    productContainer.removeEventListener('variant-changed', this.handleVariantChange)
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler)
    }
  }
}


customElements.define('main-atc', MainATC)